import React from 'react'
import { MDBRow, MDBCol } from 'mdbreact'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarDays, faClock, faUser } from '@fortawesome/pro-solid-svg-icons'
import FadeInWhenVisible from './fadeInWhenVisible'
import CustomLink from '../components/CustomLink.js'
import moment from 'moment'

class BlogAllItems extends React.Component {
  render() {
    return (
        <MDBCol md="12" className="pb-5">
          <FadeInWhenVisible>
            <h3 className="font-alt font-w-700 letter-spacing-1 title-xs-medium title-medium"> <CustomLink link={this.props.link} className="effect-noline-blog"> {this.props.title} </CustomLink> </h3>
            <p className="text-medium lines-2">{this.props.description}</p>

            <MDBRow className="justify-content-left font-alt font-w-400 text-gray-light text-medium-small letter-spacing-1">
              <MDBCol lg="auto" md="4" xs="12">
                <FontAwesomeIcon icon={faCalendarDays} className="mr-2" />{moment(this.props.date).format('YYYY/MM/DD')}
              </MDBCol>
              
              {this.props.author && ( 
              <MDBCol lg="auto" md="4" xs="12"> <FontAwesomeIcon icon={faUser} className="mr-2" />{this.props.author}</MDBCol> 
              )}

              {this.props.readtime && (
                <MDBCol lg="auto" md="4" xs="12">
                  <FontAwesomeIcon icon={faClock} className="mr-2" />{this.props.readtime} read
                </MDBCol>
              )}
            </MDBRow>
          </FadeInWhenVisible>
        </MDBCol>        
    )
  }
}
export default BlogAllItems